import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './sdk/saas-sdk.css';


const state =  {
  userinfo: {
    uId: '1234',
    utoken: 'ab555c',
  }
}

interface IBroadcastFlow {
  events?: object
}

@Component
export default class BroadcastFlow  extends tsx.Component<IBroadcastFlow> {

  @Prop() events?: object

  mounted () {
    // sdk bug 虚拟dom创建成功未能获取宽度，导致touch点位x始终为0
    setTimeout(() => {
      this.$props.events.initSdk('#devicePlay')
      // this.$props.events.startSdk('devicePlay')
    }, 1000)
  }

  render() {
    return <div id='devicePlay' />
  }

}
